import React from 'react';
import { MDBBtn } from "mdbreact";
import { Link } from 'react-router-dom';

class CheckoutForm extends React.Component {
    // Then we add our constructor which receives our props
    constructor(props) {
        super(props);
        this.state = {
            user: {
                name: '',
                organization: '',
                emailAddress: '',
                contactNumber: '',
                purpose: '',
                address1: '',
                address2: '',
                postcode: '',
                city: '',
                state: '',
                country: '',
                acceptTC: false,
                eInvoice: false,
                buyerTin: '',
                buyerType: '',
                buyerNumber: '',
                buyerSst: '',
            },

            submitted: false,
            purposes: [],
            states: [],
            countries: [],

            cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
            cartGISData: JSON.parse(localStorage.getItem("cartGISData")) || [],
            cartSTPData: JSON.parse(localStorage.getItem("cartSTPData")) || [],

            isRequiredeInvoice: false,
            isBusinessBuyer:false
        };
        this.handleInvoiceChange = this.handleInvoiceChange.bind(this);
    }

    componentDidMount() {
        fetch('api/GetData/GetConfigValues?configName=Purpose')
            .then(response => response.json())
            .then(data => {
                //console.log({ data });
                this.setState({ purposes: data, selectedOption: data[0].value });
            });

        fetch('api/GetData/GetConfigValues?configName=State')
            .then(response => response.json())
            .then(data => {
                //console.log({ data });
                this.setState({ states: data, selectedOption: data[0].value });
            });

        fetch('api/GetData/GetConfigValues?configName=Country')
            .then(response => response.json())
            .then(data => {
                //console.log({ data });
                this.setState({ countries: data, selectedOption: data[0].value });
            });
    }

    submitHandler = event => {
        event.preventDefault();
        event.target.className += " was-validated";

        this.setState({ submitted: true });
        const { user } = this.state;

        //var emailValid = user.emailAddress.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        //console.log(emailValid);

        if (user.name && user.organization && user.emailAddress && user.contactNumber && user.purpose && user.acceptTC && user.address1
            && user.address2 && user.postcode && user.city && user.state && user.country) {

            user.eInvoice = this.state.isRequiredeInvoice;

            if (this.state.isRequiredeInvoice) {  
                if (!user.buyerType) {
                    return;
                } 

                if (user.buyerType == 'B' && !user.buyerNumber) {
                    alert('Business Registration is required.');
                    return;
                } 

                if (user.buyerType == 'B' && !/^\d{12}$/.test(user.buyerNumber)) {
                    alert('Business Registration number must be exactly 12 digits.');
                    return;
                } 

                if (user.buyerType == 'B' && !user.buyerTin) {
                    alert('Tax Identification Number is required.');
                    return;
                }

                if (user.buyerType == 'B' && !user.buyerTin.endsWith('0')) {
                    alert('Tax Identification Number need to end with 0.');
                    return;
                }

                if (user.buyerType == 'M' || user.buyerType == 'N') {
                    if (!user.buyerNumber && !user.buyerTin) {
                        alert('Please at least enter either MyKad Identification Number or Tax Identification Number.');
                        return;
                    }
                }
            }

            localStorage.setItem("userInfo", JSON.stringify(user));

            var geometries = this.state.cartItems;
            var downloadableGisData = this.state.cartGISData;
            var STPData = this.state.cartSTPData;

            var myHeaders = new Headers();
            myHeaders.append('pragma', 'no-cache');
            myHeaders.append('cache-control', 'no-cache');
            myHeaders.append('Accept', 'application/json');
            myHeaders.append('Content-Type', 'application/json');

            var order = { user, geometries, downloadableGisData, STPData };

            console.log(order)

            var myInit = {
                method: 'post',
                headers: myHeaders,
                body: JSON.stringify(order)
            };

            fetch('api/Order/MakePayment', myInit)
                .then(response => response.text())
                .then(data => {
                    console.log(data);
                    if (data.includes("https:")) {
                        var url = data.substring(1, data.length - 1);
                        window.location = url;
                    } else {
                        alert(data);
                    }
                });
        }
    };

    changeHandler = (event) => {
        const { name, value } = event.target;
        const { user } = this.state;

        let updatedUser = { ...user, [name]: value };

        if (name === "buyerType") {
            const buyerNumberInput = document.getElementsByName('buyerNumber')[0];
            const buyerTinInput = document.getElementsByName("buyerTin")[0];
            updatedUser.buyerNumber = "";

            if (value === "B") {
                buyerNumberInput.placeholder = "12-digit BRN (Business Registration Number)";
                buyerTinInput.placeholder = "C20880050010 (Mandatory)";
                buyerTinInput.required = true;
                this.setState({ user: updatedUser, isBusinessBuyer: true });
            } else if (value === "M") {
                buyerNumberInput.placeholder = "MyKad/ MyTentera Identification Number";
                buyerTinInput.placeholder = "IG56003500070 (Optional)";
                buyerTinInput.required = false;
                this.setState({ user: updatedUser, isBusinessBuyer: false });
            } else if (value === "N") {
                buyerNumberInput.placeholder = "Passport Number/ MyPR/ MyKAS Identification Number";
                buyerTinInput.placeholder = "IG56003500070 (Optional)";
                buyerTinInput.required = false;
                this.setState({ user: updatedUser, isBusinessBuyer: false });
            }
        } else {
            this.setState({ user: updatedUser });
        }
    };

    handleInvoiceChange(event) {
        this.setState({ isRequiredeInvoice: event.target.checked });
        this.setState({ isBusinessBuyer: false });
    }

    onlyNumberKey = (event) => {
        // var ASCIICode = (event.which) ? event.which : event.keyCode
        // if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
        //     event.preventDefault();
        // }
        const { key, target } = event;
        const value = target.value;

        const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (navigationKeys.includes(key)) {
            return;
        }

        if (!/^\d$/.test(key)) {
            event.preventDefault();
        }
    };

    handleNumericKeyDown = (event) => {
        const { key, target } = event;
        const value = target.value;

        const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (navigationKeys.includes(key)) {
            return;
        }

        if (['B', 'M'].includes(this.state.user.buyerType)) {
            if (!/^\d$/.test(key) || value.length >= 12) {
                event.preventDefault();
            }
        }
    };

    HandleTinKeyDown = (event) => {
        const { value } = event.target;
        const key = event.key;

        const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (navigationKeys.includes(key)) {
            return;
        }

        // Prevent spaces
        if (key === ' ') {
            event.preventDefault();
            return;
        }

        // Check if the input will start with a letter
        if ((value.length === 0 && !/^[a-zA-Z]$/.test(key)) || key === '-') {
            event.preventDefault();
            return;
        }
    };

    render() {
        const { cartItems, cartGISData, cartSTPData, user, purposes, states, countries } = this.state;
        const priceTotal = (cartItems.reduce((totalPrice, item) => totalPrice + item.Price, 0) +
            cartGISData.reduce((totalPrice, item) => totalPrice + item.price, 0) +
            cartSTPData.reduce((totalPrice, item) => totalPrice + item.price, 0)).toFixed(2);
        var itemTotal = cartItems.reduce((totalPrice, item) => (totalPrice + item.Price / 1.08), 0).toFixed(2);
        var gisTotal = cartGISData.reduce((totalPrice, item) => (totalPrice + item.price / 1.08), 0).toFixed(2);
        var stpTotal = cartSTPData.reduce((totalPrice, item) => (totalPrice + item.price / 1.08), 0).toFixed(2);
        //const subTotal = (priceTotal / 1.06).toFixed(2);
        const subTotal = (parseFloat(itemTotal) + parseFloat(gisTotal) + parseFloat(stpTotal)).toFixed(2);
        const sst = (priceTotal - subTotal).toFixed(2);

        return (
            <div className="container wow fadeIn pt-4 pb-4">
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-12">
                        <div className="card">
                            <div className="p-4">
                                <div className="pb-2"><h5>User Details</h5></div>
                                <form
                                    className="needs-validation form-horizontal"
                                    onSubmit={this.submitHandler}
                                    noValidate
                                >
                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="name">Name</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="name"
                                                onChange={this.changeHandler}
                                                type="text"
                                                id="name"
                                                className="form-control"
                                                value={user.name}
                                                //placeholder="Name"
                                                required
                                            />
                                            <div className="invalid-feedback">Name is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="organization">Organization</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="organization"
                                                onChange={this.changeHandler}
                                                type="text"
                                                id="organization"
                                                className="form-control"
                                                value={user.organization}
                                                //placeholder="Name"
                                                required
                                            />
                                            <div className="invalid-feedback">Organization name is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="emailAddress">Email Address</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="emailAddress"
                                                onChange={this.changeHandler}
                                                type="email"
                                                id="emailAddress"
                                                className="form-control"
                                                value={user.emailAddress}
                                                //placeholder="Email Address"
                                                required
                                            />
                                            <div className="invalid-feedback">Email Address is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="address1">Billing Address</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="address1"
                                                onChange={this.changeHandler}
                                                type="text"
                                                id="address1"
                                                className="form-control"
                                                value={user.address1}
                                                //placeholder="Email Address"
                                                required
                                            />
                                            <div className="invalid-feedback">Billing Address is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2"></label>
                                        <div className="col-sm-8">
                                            <input
                                                name="address2"
                                                onChange={this.changeHandler}
                                                type="text"
                                                id="address2"
                                                className="form-control"
                                                value={user.address2}
                                                //placeholder="Email Address"
                                                required
                                            />
                                            <div className="invalid-feedback">Billing Address is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2"></label>
                                        <div className="col-sm-4">                                           
                                            <input
                                                name="postcode"
                                                onChange={this.changeHandler}
                                                onKeyDown={this.onlyNumberKey}
                                                type="text"
                                                id="postcode"
                                                className="form-control"
                                                value={user.postcode}
                                                maxLength="5"
                                                placeholder="Postcode"
                                                required
                                            />
                                            <div className="invalid-feedback">Postcode is required!</div>
                                        </div>
                                        <div className="col-sm-4">
                                            <input
                                                name="city"
                                                onChange={this.changeHandler}
                                                type="text"
                                                id="city"
                                                className="form-control"
                                                value={user.city}
                                                placeholder="City"
                                                required
                                            />
                                            <div className="invalid-feedback">City is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2"></label>
                                        <div className="col-sm-4">
                                            <select name="state" id="state" className="form-control" required
                                                onChange={this.changeHandler}>
                                                <option value="">State</option>
                                                {states.map(p =>
                                                    <option key={p.configValueId} value={p.value}>{p.value}</option>
                                                )}
                                            </select>
                                            <div className="invalid-feedback">State is required!</div>
                                        </div>
                                        <div className="col-sm-4">
                                            <select name="country" id="country" className="form-control" required
                                                onChange={this.changeHandler}>
                                                <option value="">Country</option>
                                                {countries.map(p =>
                                                    <option key={p.configValueId} value={p.value}>{p.value}</option>
                                                )}
                                            </select>
                                            <div className="invalid-feedback">Country is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="contactNumber">Contact Number</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="contactNumber"
                                                onChange={this.changeHandler}
                                                onKeyDown={this.onlyNumberKey}
                                                type="text"
                                                id="contactNumber"
                                                className="form-control"
                                                value={user.contactNumber}
                                                //placeholder="Email Address"
                                                required
                                            />
                                            <div className="invalid-feedback">Contact Number is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="purpose">Purpose</label>
                                        <div className="col-sm-8">
                                            <select name="purpose" id="purpose" className="form-control" required
                                                onChange={this.changeHandler}>
                                                <option value="">Choose Purpose</option>
                                                {purposes.map(p =>
                                                    <option key={p.configValueId} value={p.value}>{p.value}</option>
                                                )}
                                            </select>

                                            <div className="invalid-feedback">Purpose is required!</div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="custom-control custom-checkbox pt-2 pb-2">
                                            <input name="isRequiredeInvoice" onChange={this.handleInvoiceChange} type="checkbox" id="isRequiredeInvoice" className="custom-control-input" checked={this.state.isRequiredeInvoice} />
                                            <label className="custom-control-label" htmlFor="isRequiredeInvoice">I require e-Invoice for this purchase.</label>
                                        </div>
                                    </div>
                                    
                                    {this.state.isRequiredeInvoice && (
                                        <div className="form-group row">
                                            <div className="col-sm-4">
                                                <select name="buyerType" id="buyerType" className="form-control" onChange={this.changeHandler} required>
                                                    <option value="" disabled selected>Select your option</option>
                                                    <option value="B">Business</option>
                                                    <option value="M">Malaysian</option>
                                                    <option value="N">Non-Malaysian</option>
                                                </select>
                                            </div>
                                            <div className="col-sm-8">
                                                <input
                                                    name="buyerNumber"
                                                    onKeyDown={this.handleNumericKeyDown}
                                                    onChange={this.changeHandler}
                                                    type="text"
                                                    id="buyerNumber"
                                                    className="form-control"
                                                    value={user.buyerNumber}
                                                    placeholder="-"
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.isRequiredeInvoice && (
                                        <div className="form-group row">
                                            <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="buyerTin">Tax Identification Number</label>
                                            <div className="col-sm-8">
                                                <input
                                                    name="buyerTin"
                                                    onKeyDown={this.HandleTinKeyDown}
                                                    onChange={this.changeHandler}
                                                    type="text"
                                                    id="buyerTin"
                                                    className="form-control"
                                                    value={user.buyerTin}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.isRequiredeInvoice && this.state.isBusinessBuyer && (
                                        <div className="form-group row">
                                            <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="buyerSst">SST Registration Number</label>
                                            <div className="col-sm-8">
                                                <input
                                                    name="buyerSst"
                                                    onChange={this.changeHandler}
                                                    type="text"
                                                    id="buyerSst"
                                                    className="form-control"
                                                    value={user.buyerSst}
                                                    placeholder="-"
                                                />
                                                <div><small>*This is applicable to SST registered buyer only.</small></div>
                                            </div>
                                        </div>
                                    )}


                                    <div className="pt-2">
                                        <h5>Terms & Conditions of Service</h5>
                                        <small>Please read the following term and conditions.</small>
                                        <div className="termsx pt-2 pb-2">
                                            <p>1. Maps data and/or information (“Information”) provided are for graphical purposes only which do not represent a verified survey. While every effort has been made to ensure that this Information is accurate and reliable within the limits of the current state of the art, Indah Water Konsortium Sdn Bhd (“IWK”) shall not assume liability for any damages caused by any errors or omissions in the Information, nor as a result of the failure of the Information to function on a particular system. </p>
                                            <p>2. IWK makes no warranty, expressed or implied on the Information provided. IWK shall not be liable for any damages caused by any errors or omissions in the Information including loss of data, lost profits, business interruption, loss of business information or any other pecuniary loss that may arise from the usage of the Information. </p>
                                            <p>3. The Information is for reference only and shall not be used for any legal, engineering, surveying, waiver of any tax/contribution imposed by the Government or emergency response purposes. Users of this information should review, investigate, conduct site surveys or consult primary data and information sources to ascertain the usability of the Information. </p>
                                            <p>4. The Information provided was derived from digital databases on IWK’s Enterprise GIS and every effort has been made to ensure the accuracy of the same. Notwithstanding this, IWK shall not accept any responsibility for any errors, omissions, or positional accuracy, and therefore, there are no warranties that accompany this product. </p>
                                            <p>5. Any errors or omissions regarding the Information should be reported to IWK via e-mail or official letter. </p>
                                            <p>6. The fee imposed or charged for the Information purchased through the Indah Geoportal service represents an administrative charge for processing the request and for supporting the operation and maintenance of the Indah Geoportal digital platform. The fee does not represent ownership of the Information itself. </p>
                                            <p>7. By agreeing to these terms and conditions, you are deemed to have consented for the disclosure of your personal data by IWK, if required, and the disclosure shall be in accordance with the Personal Data Protection Act 2010 and IWK’s Privacy Notice. </p>
                                        </div>
                                        <div className="custom-control custom-checkbox pt-2 pb-2">
                                            <input name="acceptTC" onChange={this.changeHandler} type="checkbox" id="acceptTC" className="custom-control-input" value={user.acceptTC} required />
                                            <label className="custom-control-label" htmlFor="acceptTC">I have read and accept to the following terms and conditions.</label>
                                            <div className="invalid-feedback">You need to accept the terms and conditions.</div>
                                        </div>
                                    </div>

                                    <MDBBtn color="primary" type="submit">
                                        Place Order
                                    </MDBBtn>

                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <h4 className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-muted">Your cart</span>
                            <span className="badge badge-secondary badge-pill">{cartItems.length + cartGISData.length + cartSTPData.length}</span>
                        </h4>
                        <div className="card">
                            <div className="card-header">
                                <h3 className="panel-title"><strong>Order Summary</strong></h3>
                            </div>
                            <ul className="list-group list-group-flush">

                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                    <div>
                                        <h6 className="my-0">User Defined Region</h6>
                                        {cartItems.map((cartitem, index) => (
                                            <small key={index} className="text-muted bold">{cartitem.BufferId.replace('_', ' ')} - RM {(cartitem.Price / 1.08).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br /></small>
                                        ))}
                                    </div>
                                    <span className="text-muted">RM {itemTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                    <div>
                                        <h6 className="my-0">Downloadable GIS Data</h6>
                                        {cartGISData.map((gisData, index) => (
                                            <small key={index} className="text-muted">{gisData.name} - RM {(gisData.price / 1.08).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br /></small>
                                        ))}
                                    </div>
                                    <span className="text-muted">RM {gisTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                </li>
                                {<li className="list-group-item d-flex justify-content-between lh-condensed">
                                    <div>
                                        <h6 className="my-0">STP Data</h6>
                                        {cartSTPData.map((stpData, index) => (
                                            <small key={index} className="text-muted">{stpData.assetNumber} - RM {(stpData.price / 1.08).toFixed(2)}<br /></small>
                                        ))}
                                    </div>
                                    <span className="text-muted">RM {stpTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                </li>}
                                
                                <li className="list-group-item d-flex justify-content-between border-bottom-0 pb-1">
                                    <span>Sub Total</span>
                                    RM {subTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </li>
                                <li className="list-group-item d-flex justify-content-between border-0 pt-1 pb-1">
                                    <span>Service Tax 8%</span>
                                    RM {sst.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </li>
                                <li className="list-group-item d-flex justify-content-between border-0 pt-1">
                                    <strong>Grand Total</strong>
                                    <strong>RM {priceTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-sm-12 pt-3 text-center">
                        <Link className="" to="/">Go to Home </Link>
                    </div> 
                </div>               
            </div>
        )
    }
}

export default CheckoutForm;


// WEBPACK FOOTER //
// ./src/components/Checkout/CheckoutForm.js